import moment from 'moment';
import config from 'config';

const formatDate = (date) => (
  date ? moment(date).format(config.dateFormat, true) : null
);
export default formatDate;
